import {createContext} from 'react';

/**
 * Context that will be used to store data about a current session in a form of one of the API services
 */
const APIServiceFormContext = createContext();
export default APIServiceFormContext;
